import { MatrixAxis } from './table';

/** Resolves display names for matrix axis inputs (selector vs formula). */
export interface MatrixAxisSummaryContext {
    selectorLabel(keyId: string): string | undefined;
    formulaName(formulaId: string): string | undefined;
}

/** Single line label for one matrix axis (used in table headers and summaries). */
export function matrixAxisSummaryLabel(axis: MatrixAxis, ctx: MatrixAxisSummaryContext): string {
    if (axis.formulaId) {
        return ctx.formulaName(axis.formulaId) ?? axis.formulaId;
    }
    if (axis.keyId) {
        return ctx.selectorLabel(axis.keyId) ?? axis.keyId;
    }
    return '(unset)';
}
